import React from "react";
import Link from "gatsby-link";
import { endSlash } from "../util/helperFunctions";

const IntOrExtLink = ({ to, children, ...props }) => {
  return /^(https?:\/\/)?(www)?\w+\.\w+/g.test(to) ? (
    <a href={endSlash(to)} {...props} target="_blank">
      {children}
    </a>
  ) : (
    <Link to={endSlash(to)} {...props}>
      {children}
    </Link>
  );
};

export default IntOrExtLink;



// WEBPACK FOOTER //
// ./src/components/IntOrExtLink.js